var operators = ['=', '!=', '<', '>', '<=', '>=', 'AND', 'OR'];
var openingParentheses = ['(', '[', '{'];
var closingParentheses = [')', ']', '}'];
var parentheses = openingParentheses.concat(closingParentheses);
var quote = "'";
var closeToOpenParenthesesMap = {
  ')': '(',
  ']': '[',
  '}': '{'
};
export var fieldTypes = {
  INSTRUCTIONS: 'instructions',
  RADIO: 'radio',
  LIST: 'list',
  DOCUMENT_UPLOAD: 'doc upload',
  PERCENTAGE: 'percentage',
  CURRENCY: 'currency',
  PHONE: 'phone',
  DATE: 'date',
  DIGIT: 'digit',
  COMETA_SELECT: 'cometa select',
  COMETA_SELECT_CREATABLE: 'cometa select(creatable)',
  COMETA_SEARCH: 'cometa search',
  COMETA_SEARCH_CREATABLE: 'cometa search(creatable)',
  COMETA_INDUSTRY: 'cometa industry',
  CHECKBOX: 'checkbox',
  EMAIL: 'email',
  URL: 'URL',
  POSTAL_CODE_BRA: 'postal code (BRA)',
  DOWNLOAD: 'download'
};
export var attribute = {
  ID: 'id',
  STEP: 'step',
  STEP_TITLE: 'stepTitle',
  SECTION: 'section',
  LOOPING_GROUP: 'loopingGroup',
  TYPE: 'formType',
  REQUIRED: 'required',
  CONDITION: 'condition',
  RESTRICTION: 'restrictionValidation',
  TITLE: 'fieldTitle',
  LIST_VALUES: 'listValues',
  NOTE: 'note',
  CONDITION_POSTFIX: 'conditionPostfix'
};
export var selectPlaceholder = {
  en: 'Select...',
  'pt-BR': 'Selecionar...',
  es: 'Seleccionar...'
};
export var countries = {
  BRA: 'BRA',
  ONLINE_INVESTIGATION: 'CIALOnlineInvestigation',
  MEX: 'MEX',
  PER: 'PER',
  CCS: 'CCS',
  ARG: 'ARG',
  INT: 'INT'
};
export var conditionConstants = {
  operators: operators,
  quote: quote,
  parentheses: parentheses,
  openingParentheses: openingParentheses,
  closingParentheses: closingParentheses,
  closeToOpenParenthesesMap: closeToOpenParenthesesMap
};